import React, { useRef, useEffect } from "react";
import { Container } from "@pixi/react";
import DividerController from "./DividerController";

const Divider = ({ index, x, dividerDimensions }) => {
  const dividerControllerRef = useRef(null);
  const dividerContainerRef = useRef(null);

  // Initialize DividerController when assets are ready
  useEffect(() => {
    if (dividerContainerRef.current && !dividerControllerRef.current) {
      dividerControllerRef.current = new DividerController(
        dividerContainerRef.current,
        dividerDimensions
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dividerControllerRef.current) {
      dividerControllerRef.current.resizeDivider(dividerDimensions);
    }
  }, [dividerDimensions]);

  return (
    <Container
      ref={dividerContainerRef}
      name={`divider_${index + 1}`}
      x={x}
      y={0}
    ></Container>
  );
};

export default Divider;
